module.exports = __webpack_public_path__ + "static/config-banner-show-on-home-custom-68eca62f4993a50d2528147977ca45f1.png";